import { Checkbox } from "antd";
import styles from "./styles.module.css";

export const PreSalesAgreement = ({ bid, formData, setFormData }: any) => {
  const handleAgreementChange = (e: any) => {
    setFormData((prev: any) => ({ ...prev, agreed: e.target.checked }));
  };

  return (
    <>
      <div className={styles.agreementContainer}>
        <h2 className={styles.agreementTitle}>Pre-Sales Agreement</h2>

        <div className={styles.agreementSection}>
          <h3 className={styles.agreementSubtitle}>Asset Details</h3>
          <table className={styles.detailsTable}>
            <tbody>
              <tr>
                <td>Round Type:</td>
                <td>{bid?.round?.type || "N/A"}</td>
              </tr>
              <tr>
                <td>Asset Name:</td>
                <td>{bid?.title || "N/A"}</td>
              </tr>
              <tr>
                <td>Winning Bid Amount:</td>
                <td>₦{bid?.round?.currentHighBid?.toLocaleString() || "0"}</td>
              </tr>
              <tr>
                <td>Condition:</td>
                <td>{bid?.condition || "N/A"}</td>
              </tr>
              <tr>
                <td>Location:</td>
                <td>{bid?.location || "N/A"}</td>
              </tr>
              <tr>
                <td>Caveat:</td>
                <td>{bid?.caveat || "N/A"}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className={styles.agreementSection}>
          <h3 className={styles.agreementSubtitle}>1. Terms and Conditions</h3>
          <p className={styles.agreementText}>
            By accepting this pre-sales agreement, you acknowledge and agree to
            the following terms:
          </p>
          <ul className={styles.agreementList}>
            <li>The asset is sold "as-is" with no warranties or guarantees.</li>
            <li>
              Full payment must be completed within 5 business days from
              agreement acceptance.
            </li>
            <li>
              The buyer is responsible for all transportation and logistics
              costs.
            </li>
            <li>No refunds will be issued after payment confirmation.</li>
            <li>
              Asset condition has been verified and disclosed prior to bidding.
            </li>
          </ul>
        </div>

        <div className={styles.agreementSection}>
          <h3 className={styles.agreementSubtitle}>2. Payment Terms</h3>
          <p className={styles.agreementText}>
            Payment must be made through approved channels. Upon receipt of
            payment, a receipt must be uploaded to the system for verification.
            Processing time for verification is 2-3 business days.
          </p>
        </div>

        <div className={styles.agreementSection}>
          <h3 className={styles.agreementSubtitle}>3. Asset Collection</h3>
          <p className={styles.agreementText}>
            The asset must be collected within 7 days of payment confirmation.
            Failure to collect within this timeframe may result in additional
            storage fees or forfeiture of the asset.
          </p>
        </div>

        <div className={styles.agreementSection}>
          <h3 className={styles.agreementSubtitle}>
            4. Witness Requirements (Staff Only)
          </h3>
          <p className={styles.agreementText}>
            For permanent employees, two witnesses must be designated to
            validate this transaction. Witnesses must be current employees with
            no conflict of interest in this transaction.
          </p>
        </div>

        <div className={styles.agreementSection}>
          <h3 className={styles.agreementSubtitle}>5. Legal Compliance</h3>
          <p className={styles.agreementText}>
            This agreement is governed by applicable laws and regulations. Both
            parties agree to resolve any disputes through mediation before
            pursuing legal action.
          </p>
        </div>
      </div>

      <div className={styles.checkboxContainer}>
        <Checkbox
          checked={formData.agreed}
          onChange={handleAgreementChange}
          style={{ fontSize: "16px", fontWeight: "500" }}
        >
          I have read, understood, and agree to all terms and conditions stated
          above
        </Checkbox>
      </div>
    </>
  );
};
